import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const HobbleOfTheSea = {
  id: '90',
  name: 'Hobble of the Sea',
  icon: 'HobbleOfTheSea',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  power: 10,
  gameId: 'HobbleOfTheSea'
};

export default HobbleOfTheSea;
